import create from 'zustand';

type DrmPfInformationSearchStore = {
  order: string;
  setOrder: ( order: string ) => void;
  pageSize: string;
  setPageSize: ( size: string ) => void;
  checkTypeIds: number[];
  setCheckTypeIds: ( ids: number[] ) => void;
  checkKindIds: number[];
  setCheckKindIds: ( ids: number[] ) => void;
  searchText: string;
  setSearchText: ( text: string ) => void;
  searchYear: string;
  setSearchYear: ( text: string ) => void;
  currentPage: number;
  setCurrentPage: ( page: number ) => void;
  backPage: string;
  setBackPage: ( backPage: string ) => void;
};

const useDrmPfInformationSearchStore = create<DrmPfInformationSearchStore>(( set ) => ({
  order: "1",
  setOrder: ( order ) =>
    set(state => ({
      order: order,
    })),
  pageSize: "20",
  setPageSize: ( size ) =>
    set(state => ({
      pageSize: size
    })),
  checkTypeIds: [],
  setCheckTypeIds: ( ids ) =>
    set(state => ({
      checkTypeIds: ids
    })),
  checkKindIds: [],
  setCheckKindIds: ( ids ) =>
    set(state => ({
      checkKindIds: ids
    })),
  searchText: "",
  setSearchText: ( text ) =>
    set(state => ({
      searchText: text
    })),
  searchYear: "",
  setSearchYear: ( text ) =>
    set(state => ({
      searchYear: text
    })),
  currentPage: 0,
  setCurrentPage: ( page ) =>
    set(state => ({
      currentPage: page
    })),
  backPage: "/",
  setBackPage: ( backPage ) =>
    set(state => ({
      backPage: backPage
    })),
}));

export function useDrmPfInformationSearch() {
  const state = useDrmPfInformationSearchStore();
  return {
    ...state,
  };
}